import { Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { MoreVert } from '@material-ui/icons';
import { formatTime } from '../utils/Utils';
import FlagIcon from '../../assets/FlagIcon';
import Image from '../common/Image';

const useStyle = makeStyles({
  video: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  videoInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'center',
  },
  thumbnail: {
    width: '80px',
    height: '70px',
  },
  content: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  interaction: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  flag: {
    width: '70px',
    height: '70px',
    background: '#EBE9FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
});

export function VideoCard({ data, imageList, index, handleAction }) {
  const classes = useStyle();
  return (
    <Grid className={classes.video}>
      <Grid className={classes.thumbnail}>
        <Image src={imageList[index]} alt="thumbnail" style={{ height: '100%', width: '100%' }} loading="lazy" />
      </Grid>
      <Grid className={classes.videoInfo}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          style={{
            width: '35vw',
          }}
        >
          <Typography>{data.title}</Typography>
          <div>
            <MoreVert style={{ cursor: 'pointer' }} onClick={(e) => handleAction(e, data, 'video', index)} />
          </div>
        </Grid>

        <Typography variant="p" style={{ fontSize: '12px' }}>
          {formatTime(data.duration)}
        </Typography>
      </Grid>
    </Grid>
  );
}

export function ContentCard({ data }) {
  const classes = useStyle();
  return (
    <Grid className={classes.content}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: data.overview }} />
    </Grid>
  );
}

export function InteractionCard({ data, index, handleAction }) {
  const classes = useStyle();
  return (
    <Grid className={classes.interaction}>
      <Grid className={classes.flag}>
        <FlagIcon style={{ width: '50%', height: '50%' }} />
      </Grid>
      <Grid className={classes.videoInfo}>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '35vw',
          }}
        >
          <Typography>{data.title}</Typography>
          <div>
            <MoreVert style={{ cursor: 'pointer' }} onClick={(e) => handleAction(e, data, 'interaction', index)} />
          </div>
        </Grid>

        <Typography variant="p" style={{ fontSize: '12px' }}>
          {data.type}
        </Typography>
      </Grid>
    </Grid>
  );
}
